const PAGINATION_DISPLAY_NUMBER = 5;

export default PAGINATION_DISPLAY_NUMBER;